export const Dutch = {
  Features: "Functies",
  Blog: "Blog",
  Trade: "Handel",
  trade: "handel",
  Buy: "Kopen/Verkopen",
  Download: "Downloaden",
  The: "De",
  gateway: "gateway",
  to: "naar",
  To: "Naar",
  the: "de",
  next: "volgende",
  generation: "generatie",
  of: "van",
  Gamers: "Gamer",
  Your: "Jouw",
  games: "spellen",
  coins: "munten",
  All: "Alle",
  in: "in",
  one: "één",
  place: "plaats",
  Simple: "Eenvoudig",
  fun: "leuk",
  and: "en",
  And: "En",
  super: "super",
  smart: "slim",
  Scan: "Scannen",
  download: "downloaden",
  app: "app",
  Available: "Beschikbaar",
  on: "op",
  assets: "activa",
  Assets: "activa",
  Game: "Spel",
  game: "spel",
  Connect: "Verbinden",
  thirdparty: "derde partij",
  Crypto: "Crypto",
  Card: "Kaart",
  Authentication: "Authenticatie",
  Own: "Eigendom",
  your: "jouw",
  earn: "verdien",
  is: "is",
  Is: "Is",
  easy: "makkelijk",
  way: "manier",
  store: "opslaan",
  manage: "beheren",
  winnings: "winsten",
  Whether: "Of je nu",
  youre: "je bent",
  Youre: "Je bent",
  competitive: "competitieve",
  gamer: "gamer",
  or: "of",
  just: "gewoon",
  casual: "casual",
  player: "speler",
  has: "heeft",
  something: "iets",
  for: "voor",
  everyone: "iedereen",
  effortlessly: "zonder moeite",
  converts: "converteert",
  into: "in",
  preferred: "voorkeurs-",
  cryptocurrency: "cryptocurrency",
  start: "start",
  earning: "verdienen",
  Exclusive: "Exclusieve",
  content: "inhoud",
  experiences: "ervaringen",
  now: "nu",
  at: "bij",
  fingertips: "vingertoppen",
  passport: "paspoort",
  unlock: "ontgrendelen",
  favourite: "favoriete",
  need: "nodig",
  do: "doen",
  connect: "verbinden",
  any: "elk",
  other: "ander",
  Gaming: "Gaming",
  Platform: "Platform",
  account: "account",
  Once: "Eenmaal",
  connected: "verbonden",
  youll: "je zult",
  Youll: "Je zult",
  be: "zijn",
  able: "in staat",
  rewards: "beloningen",
  unlocking: "ontgrendelen",
  instantly: "onmiddellijk",
  enjoying: "genieten van",
  powered: "aangedreven door",
  by: "door",
  will: "zal",
  launch: "lanceren",
  token: "token",
  listing: "vermelding",
  major: "belangrijk",
  coming: "komende",
  soon: "binnenkort",
  participate: "deelnemen",
  our: "onze",
  premium: "premium",
  collections: "collecties",
  you: "jij",
  You: "Jij",
  must: "moet",
  signup: "aanmelden",
  get: "krijgen",
  verified: "geverifieerd",
  buy: "kopen",
  using: "gebruikmakend van",
  respectively: "respectievelijk",
  Smartest: "Slimste",
  Safe: "Veilig",
  Secure: "Beveiligd",
  Earn: "Verdien",
  Big: "Groot",
  Join: "Doe mee",
  Trend: "Trend",
  Dont: "Niet",
  left: "overgelaten",
  behind: "achter",
  Welcome: "Welkom",
  world: "wereld",
  possibilities: "mogelijkheden",
  space: "ruimte",
  no: "geen",
  longer: "langer",
  thing: "ding",
  it: "het",
  present: "aanwezig",
  Over: "Over",
  invested: "geïnvesteerd",
  projects: "projecten",
  past: "verleden",
  year: "jaar",
  free: "gratis",
  easiest: "makkelijkste",
  anywhere: "overal",
  anytime: "altijd",
  Use: "Gebruik",
  accepted: "geaccepteerd",
  from: "van",
  online: "online",
  globally: "wereldwijd",
  With: "Met",
  an: "een",
  instant: "direct",
  cash: "geld",
  conversions: "conversies",
  can: "kan",
  spend: "uitgeven",
  without: "zonder",
  hassles: "moeite",
  top: "top",
  notch: "klasse",
  security: "veiligheid",
  blockchain: "blockchain",
  backbone: "ruggengraat",
  are: "zijn",
  always: "altijd",
  safe: "veilig",
  perfect: "perfect",
  most: "meest",
  out: "uit",
  Rewarding: "Belonend",
  complete: "volledig",
  control: "controle",
  over: "over",
  funds: "fondsen",
  while: "terwijl",
  prioritizing: "prioriterend",
  gaming: "gaming",
  back: "terug",
  with: "met",
  every: "elke",
  use: "gebruik",
  today: "vandaag",
  level: "niveau",
  up: "omhoog",
  rules: "regels",
  only: "alleen",
  keys: "sleutels",
  so: "dus",
  Our: "Onze",
  audited: "gecontroleerd",
  audit: "controle",
  firms: "bedrijven",
  constantly: "voortdurend",
  reviewed: "beoordeeld",
  ensure: "zorgen voor",
  maximum: "maximaal",
  Convenience: "Gemak",
  moment: "moment",
  WAYS: "MANIEREN",
  AUTHENTICATION: "AUTHENTICATIE",
  TO: "OM",
  STRENGTHEN: "TE VERSTER",
  YOUR: "JOUW",
  ASSETS: "ACTIVA",
  SAFETY: "VEILIGHEID",
  enjoy: "genieten van",
  all: "alle",
  this: "dit",
  amazing: "geweldig",
  functionalities: "functionaliteiten",
  A: "Een",
  Decentralized: "Gedecentraliseerde",
  wallet: "portemonnee",
  dedicated: "toegewijd",
  Home: "Thuis",
  Marketplace: "Marktplaats",
  Privacy: "Privacy",
  Policy: "Beleid",
  Terms: "Voorwaarden",
  Service: "Service",
  Navigation: "Navigatie",
  Products: "Producten",
  Legal: "Juridisch",
  What: "Wat",
  How: "Hoe",
  blockchains: "blockchains",
  does: "doet",
  support: "steun",
  types: "soorten",
  deposit: "borg",
  withdraw: "terugtrekken",
  earned: "verdiend",
  my: "Mijn",
  I: "I",
};
